import styled from "styled-components";
import { COLORS } from "../../../constants/Styles";

const SEARCH_BAR_WIDTH = "339px";

export const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: ${SEARCH_BAR_WIDTH};
  border-radius: 100px;
  padding: 0.5rem;
  background-color: ${COLORS.darkGray};

  > * {
    opacity: 0.5;
  }
`;

export const SearchBarInput = styled.input`
  color: ${COLORS.secondary};
  width: ${SEARCH_BAR_WIDTH};
`;
